<template>
  <div class="col-12" style="margin-bottom: 4em;" id="add-vital">
    <div v-if="deviceToAddVital.identifier == 'MinttiHealthMonitor' || deviceToAddVital.identifier == 'MinttiVision'" style="display: flex;justify-content: center;align-items: center;">
      <span style="font-size:2em;">
        <i v-if="batteryLevel > 75" class="fas fa-battery-full" style="color: green;padding-right:0.2em"></i>
        <i v-if="batteryLevel > 50 && batteryLevel <= 75" class="fas fa-battery-three-quarters" style="color: green;padding-right:0.2em"></i>
        <i v-if="batteryLevel > 25 && batteryLevel <= 50" class="fas fa-battery-half" style="color: green;padding-right:0.2em"></i>
        <i v-if="batteryLevel > 0 && batteryLevel <= 25" class="fas fa-battery-quarter" style="color: red;padding-right:0.2em"></i>
        <i v-if="batteryLevel <= 0" class="fas fa-battery-empty" style="color: red;padding-right:0.2em"></i>
      </span>
      <i v-if="IS_CHARGING" class="fas fa-bolt" style="color: green;padding-right:0.4em;font-size:0.7em;"></i>
      <span v-if="batteryLevel > 0" style="font-size:0.7em"> {{ batteryLevel }}%</span>
    </div>
    <div class="row" style="margin-bottom:2em;justify-content: center;">
      <div class="tui-datepicker-input tui-datetime-input tui-has-focus" style="border-radius: 10em; height: 2.9em; border-color: rgb(227, 227, 227);margin-left: 0.5em;">
        <input type="text" id="start-date" aria-label="Date-Time" style="border-radius: 10em; padding-top: 0.9em; padding-bottom: 0.9em; padding-left: 1.9em; padding-right: 1.9em;" :readonly="true" />
        <span class="tui-ico-date"></span>
      </div>
      <div id="date-picker" style="margin-top: -1px"></div>
    </div>
    <div class="row" style="width: 100vw;padding-left: 0.5em;padding-right: 0.5em;" v-if="showVitals">
      <div class="col-12" style="margin-bottom: 2em;" v-for="vital in vitals" :key="vital.identifier" :style="vitalToAdd && vitalToAdd.identifier && vitalToAdd.identifier != vital.identifier ? 'display: none;' : ''">
        <div v-if="!vitalToAdd || (vitalToAdd && vitalToAdd.identifier && vitalToAdd.identifier == vital.identifier)">
          <div class="row" style="align-items: center;justify-content: center;">
            <div class="col-4 pr-0 pl-0" style="display: flex;flex-direction: column;align-items: center;" v-if="vital.icon && vital.icon.assetName">
              <div class="icon icon-circle mb-4 pb-4 ml-0" style="width: 4.5em;height: 4.5em;text-align: center;background-color: #f9f8f8;box-shadow:none;   margin-bottom: 0em !important;" :class="`icon-info`">
                <img class="device-vital-image" :src="require('@/assets/img/vitals/' + vital.icon.assetName)" />
              </div>
              <div>
                {{ vital.displayName[$i18n.locale] || vital.displayName['en-US'] }}
              </div>
            </div>
          </div>

          <div class="row" style="margin-top: 2em">
            <div style="width:100%;">
              <range-slider @valueUpdated="(v) => { vital.value = v }" :start="vital.validations && vital.validations.greaterThan ? vital.validations.greaterThan : null" :end="vital.validations && vital.validations.lessThan ? vital.validations.lessThan : null" :value="vital.value" :step="vital.ui && vital.ui.steps ? vital.ui.steps : null"></range-slider>
              <div style="text-align: center;margin-top: 2em;line-height: 0px;" v-if="receiving && continuousDevice">
                {{ getValue(vital) }}
              </div>
              <div style="text-align: center;" :style="receiving && continuousDevice ? 'margin-top: 0.5em;line-height: 24px;' : 'margin-top: 2em;'">
                {{ vital.unit.primary }}
              </div>
            </div>
          </div>

          <div class="row" v-if="errorMessages[vital.identifier] &&
            errorMessages[vital.identifier].length > 0
            ">
            <div class="col-12 text-danger">
              {{ $t("message.Invalid") }}
            </div>
          </div>

          <div class="col-12" v-if="vital.identifier == 'glucose'" style="width:100%;margin-top:2em;padding: 0px;">
            <div class="row">
              <div class="col-4" style="text-align:center">
                <card :class="{ 'selected-period': glucosePeriod == 'fasting' }" @click.native="setGlucosePeriod('fasting')">
                  <i class="fas fa-utensils" style="font-size: 2em;"></i>
                  <br>
                  <span style="font-size: 0.8em;">{{ $t("message.Fasting!") }}</span>
                </card>
              </div>
              <div class="col-4" style="text-align:center">
                <card :class="{ 'selected-period': glucosePeriod == 'postmeal' }" @click.native="setGlucosePeriod('postmeal')">
                  <i class="fas fa-utensils" style="font-size: 2em;"></i>
                  <br>
                  <span style="font-size: 0.8em;">{{ $t("message.Post-meal") }}</span>
                </card>
              </div>
              <div class="col-4" style="text-align:center">
                <card :class="{ 'selected-period': glucosePeriod == 'premeal' }" @click.native="setGlucosePeriod('premeal')">
                  <i class="fas fa-utensils" style="font-size: 2em;"></i>
                  <br>
                  <span style="font-size: 0.8em;">{{ $t("message.Pre-meal") }}</span>
                </card>
              </div>
              <div class="col-4" style="text-align:center">
                <card :class="{ 'selected-period': glucosePeriod == 'beforesleep' }" @click.native="setGlucosePeriod('beforesleep')">
                  <i class="fas fa-moon" style="font-size: 2em;"></i>
                  <br>
                  <span style="font-size: 0.8em;">{{ $t("message.Before Sleep") }}</span>
                </card>
              </div>
              <div class="col-4" style="text-align:center">
                <card :class="{ 'selected-period': glucosePeriod == 'random' }" @click.native="setGlucosePeriod('random')">
                  <i class="fas fa-random" style="font-size: 2em;"></i>
                  <br>
                  <span style="font-size: 0.8em;">{{ $t("message.Random") }}</span>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-12" style="text-align:center;padding: 0px;">
      <n-button v-if="deviceToAddVital.communication.communicationType == 'OCR'" @click.native="goToScan()" simple style="margin-right: 0.8em;" type="primary" size="lg">
        <i class="fa fa-camera-retro"></i> Scan
      </n-button>
      <n-button v-if="deviceToAddVital.communication.communicationType != 'MANUAL' &&
        deviceToAddVital.communication.communicationType != 'OCR' && deviceToAddVital.communication.communicationMethod == 'FETCH'
        " type="primary" size="lg" simple style="margin-right: 0.8em;" @click.native="retrieveVital(deviceToAddVital)">
        <i class="fa fa-arrow-down"></i> Retrieve
      </n-button>
      <n-button v-if="deviceToAddVital.communication.communicationType != 'MANUAL' &&
        deviceToAddVital.communication.communicationType != 'OCR' && deviceToAddVital.communication.communicationMethod == 'SYNC'
        " type="primary" size="lg" simple style="margin-right: 0.8em;" @click.native="retrieveVital(deviceToAddVital)">
        <i class="fas fa-sync"></i> Sync
      </n-button>
      <n-button v-if="deviceToAddVital.communication.communicationType != 'MANUAL' &&
        deviceToAddVital.communication.communicationType != 'OCR' && deviceToAddVital.communication.communicationMethod == 'NOTIFY'
        " type="primary" size="lg" simple style="margin-right: 0.8em;" @click.native="retrieveVital(deviceToAddVital)">
        <i class="fa fa-arrow-down"></i> Retrieve
      </n-button>
      <n-button v-if="deviceToAddVital.communication.communicationType != 'MANUAL' &&
        deviceToAddVital.communication.communicationType != 'OCR' && deviceToAddVital.communication.communicationMethod == 'SCAN'
        " type="primary" size="lg" simple style="margin-right: 0.8em;" @click.native="retrieveVital(deviceToAddVital)">
        <i class="fas fa-sync"></i> Retrieve
      </n-button>
      <n-button v-if="!(deviceToAddVital.identifier == 'MinttiHealthMonitor' || deviceToAddVital.identifier == 'MinttiVision') &&
        deviceToAddVital.communication.communicationType != 'MANUAL' &&
        deviceToAddVital.communication.communicationType != 'OCR' && deviceToAddVital.communication.communicationMethod == 'MEASURE'
        && !receiving" type="primary" size="lg" simple style="margin-right: 0.8em;" @click.native="retrieveVital(deviceToAddVital)">
        <i class="fas fa-sync"></i> Start
      </n-button>
      <n-button v-if="(deviceToAddVital.identifier == 'MinttiHealthMonitor' || deviceToAddVital.identifier == 'MinttiVision') && batteryLevel > 15 &&
        deviceToAddVital.communication.communicationType != 'MANUAL' &&
        deviceToAddVital.communication.communicationType != 'OCR' && deviceToAddVital.communication.communicationMethod == 'MEASURE'
        && !receiving" type="primary" size="lg" simple style="margin-right: 0.8em;" @click.native="retrieveVital(deviceToAddVital)">
        <i class="fas fa-sync"></i> Start
      </n-button>
      <n-button v-if="deviceToAddVital.communication.communicationType != 'MANUAL' &&
        deviceToAddVital.communication.communicationType != 'OCR' && deviceToAddVital.communication.communicationMethod == 'MEASURE'
        && receiving && continuousDevice
        " type="primary" size="lg" simple style="margin-right: 0.8em;" @click.native="stopVital(deviceToAddVital)">
        <i class="fas fa-sync"></i> Stop
      </n-button>
      <n-button type="primary" v-if="!hideSaveButton && deviceToAddVital.communication.communicationMethod != 'SYNC'" size="lg" @click.native="uploadVitals()">
        <i class="fas fa-cloud-upload-alt"></i> {{ $t("message.Save") }}
      </n-button>
    </div>

    <div v-if="batteryLevel > 15 && (!IS_CHARGING)">
      <div v-if="deviceToAddVital && (deviceToAddVital.identifier == 'MinttiHealthMonitor' || deviceToAddVital.identifier == 'MinttiVision') && vitalToAdd && vitalToAdd.identifier == 'glucose'">
        <span> {{ MinttiGlucometerMessage }} </span>
      </div>
    </div>

    <div v-if="deviceToAddVital && (deviceToAddVital.identifier == 'MinttiHealthMonitor' || deviceToAddVital.identifier == 'MinttiVision') && batteryLevel < 15" class="col-12 text-center mb-5 p-4">
      <div class="low-battery-text">
        {{ lowBatteryMessage }}
      </div>
    </div>

    <n-button type="primary" round style="position: fixed;bottom: 0px;left: 50%;transform: translate(-50%);z-index: 9999;" v-if="deviceToAddVital && deviceToAddVital.communication && deviceToAddVital.communication.fetchPerVital && vitalToAdd && vitalToAdd.identifier && deviceToAddVital.help && deviceToAddVital.help.vitalsHelp && deviceToAddVital.help.vitalsHelp[vitalToAdd.identifier] && Object.keys(deviceToAddVital.help.vitalsHelp[vitalToAdd.identifier]).length > 0" @click.native="goTohelp(deviceToAddVital.help.vitalsHelp[vitalToAdd.identifier])">
      <i class="fas fa-info-circle"></i>
      Help
    </n-button>
  </div>
</template>
<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import DatePicker from "tui-date-picker";
import { mapState } from "vuex";
import {
  vitalsFetch,
  syncAppleHealthKit,
  syncGoogleFit,
  triggerStartVitalsMeasure,
  stopVitalsMeasure,
  connect,
  disconnect,
  getBatteryValue,
  isCharging,
  delay,
} from "../../../utils/device.js";
import moment from "moment";
import { create, all } from "mathjs";
import RangeSlider from "../../../pages/../components/RangeSlider.vue";
const math = create(all, {});

export default {
  name: "addvital",
  components: {
    RangeSlider,
  },
  data() {
    return {
      triggerStartVitalsMeasureTimeout: null,
      IS_NURSE: false,
      IS_PATIENT: false,
      glucosePeriod: "fasting",
      showVitals: true,
      date: null,
      receiving: false,
      continuousDevice: false,
      loader: null,
      response: null,
      batteryLevel: 0,
      IS_CHARGING: false,
      lowBatteryMessage: "",
      MinttiGlucometerMessage: "Ensure the test paper strip is insterted",
      timeout: null,
    };
  },
  props: ["hideSaveButton"],

  async mounted() {
    this.IS_NURSE = this.user.roles.includes("nurse");
    this.IS_PATIENT = this.user.roles.includes("patient");

    DatePicker.localeTexts["calendarLanguage"] = this.calendarLanguageObject();

    this.date = new DatePicker("#date-picker", {
      language: "calendarLanguage",
      date: new Date(),
      input: {
        element: "#start-date",
        format: "dd-MM-yyyy HH:mm A",
      },
      timepicker: {
        showMeridiem: true,
      },
    });

    if (
      this.vitalToAdd &&
      this.vitalToAdd.identifier &&
      this.deviceToAddVital.communication &&
      this.deviceToAddVital.communication.config &&
      this.deviceToAddVital.communication.config.measuringMode &&
      this.deviceToAddVital.communication.config.measuringMode[
      this.vitalToAdd.identifier
      ] &&
      this.deviceToAddVital.communication.config.measuringMode[
      this.vitalToAdd.identifier
      ] == "continuous"
    ) {
      this.continuousDevice = true;
    } else if (
      this.$store.state.vitalGroupIdentifier &&
      this.deviceToAddVital.communication.config.measuringMode[
      this.$store.state.vitalGroupIdentifier
      ] == "continuous"
    ) {
      this.continuousDevice = true;
    }

    if (
      this.deviceToAddVital.identifier == "MinttiHealthMonitor" ||
      this.deviceToAddVital.identifier == "MinttiVision"
    ) {
      await this.getBatteryDetails();
    }

    // Join room with endpoint name
    /*     let roomname = "control-hub:" + this.endpoint.name;
    console.log("joining room : ", roomname);
    socket.emit("joinRoom", {
      type: "endpoint",
      id: roomname,
    }); */
    socket.emit("joinRoom", {
      type: "endpoint",
      id: this.user.endpoint.name,
    });
    console.log("joined room", this.user.endpoint.name);
    socket.on("control-hub:gotvital", (data) => {
      if (data.type == "error") {
        clearTimeout(this.timeout);
        this.loader.hide();
        this.receiving = false;
        swal.fire({
          type: "error",
          title: this.$t("message.bookings4"),
          text: this.$t("message.vitals8"),
        });
        return;
      }

      if (
        data.data &&
        data.data.content &&
        data.data.content.event &&
        data.data.content.event.value == "readingEnd"
      ) {
        this.receiving = false;
        this.showVitals = false;
        setTimeout(() => {
          this.showVitals = true;
        }, 100);
        this.$forceUpdate();
      } else {
        this.addVital(data.data);
        let vitalIdentifier = this.vitalToAdd
          ? this.vitalToAdd.identifier
          : this.$store.state.vitalGroupIdentifier;
        if (vitalIdentifier == "bp") {
          this.loader.hide();
          this.receiving = false;
          this.showVitals = false;
          setTimeout(() => {
            this.showVitals = true;
          }, 100);
          this.$forceUpdate();
        }
      }
    });
  },
  beforeDestroy() {
    try {
      socket.emit("control-hub:disconnect", {
        endpoint: this.endpoint.name,
        deviceIdentifier: this.deviceToAddVital.identifier,
      });
    } catch (e) {
      console.log(e);
    }
    if (this.loader && this.loader.hide) {
      this.loader.hide();
    }
  },
  methods: {
    setGlucosePeriod(s) {
      this.glucosePeriod = s;
    },

    async getBatteryDetails() {
      if (
        this.deviceToAddVital.communication &&
        this.deviceToAddVital.communication.config &&
        this.deviceToAddVital.communication.config.fetchMode === "gateway"
      ) {
        let that = this;
        this.loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        try {
          /*         await delay(2000);
        // let res = await getBatteryValue(this.deviceToAddVital); */

          //TODO: Send socket to get battery status
          let res = await this.$store.dispatch("getDeviceBattery", {
            endpointName: this.endpoint.name,
            deviceIdentifier: this.deviceToAddVital.identifier,
            timeout: 20000,
          });
          if (res.type === "error") {
            throw new Error("Error getting battery");
          }
          that.batteryLevel = res.batteryValue;
          if (res.batteryValue > 0) {
            if (that.batteryLevel > 15) {
              that.lowBatteryMessage =
                "Low battery, please connect to a charger";
            }
          }
          that.loader.hide();
        } catch (e) {
          if (this.loader) {
            this.loader.hide();
          }
          swal.fire({
            type: "error",
            title: "Device not detected",
          });
          this.lowBatteryMessage = "Unable to connect to device !";
          console.log(e);
        }
      } else {
        try {
          this.loader = this.$loading.show({
            // Optional parameters
            container: null,
            canCancel: false,
          });
          await connect(this.deviceToAddVital);
          await delay(2000);
          // let res = await getBatteryValue(this.deviceToAddVital);

          let getBatteryInterval = setInterval(async () => {
            try {
              let res = await getBatteryValue(this.deviceToAddVital);
              console.log("battery detials : ", res);
              this.batteryLevel = res.batteryValue;
              if (res.batteryValue > 0) {
                this.loader.hide();

                if (this.batteryLevel > 15) {
                  this.lowBatteryMessage =
                    "Low battery, please connect to a charger";
                }

                await disconnect(this.deviceToAddVital);
                clearInterval(getBatteryInterval);
              }
            } catch (e) {
              console.log(e);
            }
          }, 1000);

          setTimeout(async () => {
            console.log("timed out ...");
            this.loader.hide();
            clearInterval(getBatteryInterval);

            // Charging check not working for new mintti firmware
            // try {
            //   let res = await isCharging(this.deviceToAddVital);
            //   console.log("charging status", res);
            //   if (res && res.isCharging) {
            //     clearInterval(getBatteryInterval);
            //     this.IS_CHARGING = true;
            //   }
            // } catch (e) {
            //   console.log(e);
            // }

            if (!this.batteryLevel) {
              await disconnect(this.deviceToAddVital);
            }
          }, 5000);
        } catch (e) {
          if (this.loader) {
            this.loader.hide();
          }
          swal.fire({
            type: "error",
            title: "Device not detected",
          });
          this.lowBatteryMessage = "Unable to connect to device !";
          console.log(e);
        }
      }
    },

    async retrieveVital(device) {
      let that = this;
      if (
        this.deviceToAddVital.communication &&
        this.deviceToAddVital.communication.config &&
        this.deviceToAddVital.communication.config.fetchMode === "gateway"
      ) {
        if (device.communication.communicationMethod == "MEASURE") {
          if (this.receiving) {
            this.receiving = false;
            stopVitalsMeasure(
              device,
              this.vitalToAdd || {
                identifier: that.$store.state.vitalGroupIdentifier,
              },
              (response) => {
                console.log(response);
              },
              (err) => {
                console.log(err);
              }
            );
            if (this.response) {
              this.response.data.forEach((measuredVital) => {
                that.vitals.forEach((vital) => {
                  if (vital.identifier == measuredVital.type) {
                    let convertedVital = that.handleUnitConversion(vital.unit, {
                      name: measuredVital.type,
                      value: Number(measuredVital.value),
                      unit: measuredVital.unit,
                    });

                    if (convertedVital.value % 1 == 0) {
                      vital.value = convertedVital.value;
                    } else {
                      vital.value = math.format(convertedVital.value, {
                        notation: "fixed",
                        precision: 2,
                      });
                    }
                    vital.unit.primary = convertedVital.unit;
                    return;
                  }
                });
              });

              this.receiving = false;

              console.log(JSON.stringify(device));
              that.showVitals = false;
              setTimeout(() => {
                that.showVitals = true;
              }, 100);
              this.loader.hide();
              that.$forceUpdate();
            }
          } else {
            this.response = null;
            this.loader = this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            this.receiving = true;

            let vitalIdentifier = this.vitalToAdd
              ? this.vitalToAdd.identifier
              : that.$store.state.vitalGroupIdentifier;

            try {
              let data = await this.$store.dispatch(
                "triggerStartVitalsMeasure",
                {
                  endpointName: this.endpoint.name,
                  deviceIdentifier: device.identifier,
                  vitalIdentifier: vitalIdentifier,
                  timeout: 20000,
                }
              );

              console.log("data", data);

              if (data.type == "success" && data.content) {
                if (data.content.continuous) {
                  this.addVital(data);
                  this.loader.hide();
                } else if (!data.content.delay) {
                  this.addVital(data);
                  this.receiving = false;
                  this.showVitals = false;
                  setTimeout(() => {
                    this.showVitals = true;
                  }, 100);
                  this.loader.hide();
                  this.$forceUpdate();
                }

                if (data.content.delay) {
                  this.timeout = setTimeout(() => {
                    if (this.receiving) {
                      this.loader.hide();
                      this.receiving = false;
                      swal.fire({
                        type: "error",
                        title: that.$t("message.bookings4"),
                        text: that.$t("message.vitals8"),
                      });
                    }
                  }, 60000);
                }
              } else {
                this.loader.hide();
                this.receiving = false;
                swal.fire({
                  type: "error",
                  title: that.$t("message.bookings4"),
                  text: that.$t("message.vitals8"),
                });
              }
            } catch (e) {
              console.log(e);
              this.receiving = false;
              this.loader.hide();

              let message = this.$t("message.home36");
              if (
                e &&
                e.response &&
                e.response.data &&
                e.response.data.message
              ) {
                if (e.response.data.message == "Client timed out") {
                  message = this.$t("message.Gateway not running");
                }
              }

              swal.fire({
                type: "error",
                title: this.$t("message.Could not fetch vital!"),
                text: message,
                timer: 3000,
              });
            }
          }
        }
      } else {
        if (device.communication.communicationMethod == "FETCH") {
          try {
            let response = await vitalsFetch(device);
            console.log(response);
            response.data.forEach((measuredVital) => {
              that.vitals.forEach((vital) => {
                if (vital.identifier == measuredVital.type) {
                  let convertedVital = that.handleUnitConversion(vital.unit, {
                    name: measuredVital.type,
                    value: Number(measuredVital.value),
                    unit: measuredVital.unit,
                  });

                  if (convertedVital.value % 1 == 0) {
                    vital.value = convertedVital.value;
                  } else {
                    vital.value = math.format(convertedVital.value, {
                      notation: "fixed",
                      precision: 2,
                    });
                  }
                  vital.unit.primary = convertedVital.unit;
                  return;
                }
              });
            });
            console.log(JSON.stringify(device));
            that.showVitals = false;
            setTimeout(() => {
              that.showVitals = true;
            }, 100);
            that.$forceUpdate();
          } catch (err) {
            swal.fire({
              type: "error",
              title: that.$t("message.bookings4"),
              text: that.$t("message.vitals8"),
            });
            console.log("Error fetching data from device", err);
            if (that.connectedDevicesEnabled) {
              disconnect(that.deviceToAddVital);
            }
          }
        } else if (device.communication.communicationMethod == "SYNC") {
          if (
            device.identifier == "AppleHealthKit" &&
            device.manufacturer == "apple" &&
            device.model == "applewatch7" &&
            device.type == "vitals" &&
            device.vitals
          ) {
            try {
              let response = await syncAppleHealthKit(device);
              response.data.forEach((measuredVital) => {
                that.vitals.forEach((vital) => {
                  if (vital.identifier == measuredVital.type) {
                    let convertedVital = that.handleUnitConversion(vital.unit, {
                      name: measuredVital.type,
                      value: Number(measuredVital.value),
                      unit: measuredVital.unit,
                    });

                    if (convertedVital.value % 1 == 0) {
                      vital.value = convertedVital.value;
                    } else {
                      vital.value = math.format(convertedVital.value, {
                        notation: "fixed",
                        precision: 2,
                      });
                    }
                    vital.unit.primary = convertedVital.unit;
                    return;
                  }
                });
              });
              that.showVitals = false;
              setTimeout(() => {
                that.showVitals = true;
              }, 100);
              that.$forceUpdate();
            } catch (err) {
              swal.fire({
                type: "error",
                title: that.$t("message.bookings4"),
                text: that.$t("message.vitals8"),
              });
              console.log("Error syncing data from device", err);
              if (that.connectedDevicesEnabled) {
                disconnect(that.deviceToAddVital);
              }
            }
          }
          if (
            device.identifier == "GoogleFit" &&
            device.manufacturer == "google" &&
            device.type == "vitals" &&
            device.vitals
          ) {
            try {
              let response = await syncGoogleFit(device);
              response.data.forEach((measuredVital) => {
                that.vitals.forEach((vital) => {
                  if (vital.identifier == measuredVital.type) {
                    let convertedVital = that.handleUnitConversion(vital.unit, {
                      name: measuredVital.type,
                      value: Number(measuredVital.value),
                      unit: measuredVital.unit,
                    });

                    if (convertedVital.value % 1 == 0) {
                      vital.value = convertedVital.value;
                    } else {
                      vital.value = math.format(convertedVital.value, {
                        notation: "fixed",
                        precision: 2,
                      });
                    }
                    vital.unit.primary = convertedVital.unit;
                    return;
                  }
                });
              });
              console.log(JSON.stringify(device));
              that.showVitals = false;
              setTimeout(() => {
                that.showVitals = true;
              }, 100);
              that.$forceUpdate();
            } catch (err) {
              swal.fire({
                type: "error",
                title: that.$t("message.bookings4"),
                text: that.$t("message.vitals8"),
              });
              console.log("Error syncing data from device", err);
              if (that.connectedDevicesEnabled) {
                disconnect(that.deviceToAddVital);
              }
            }
          }
        } else if (device.communication.communicationMethod == "NOTIFY") {
        } else if (device.communication.communicationMethod == "SCAN") {
        } else if (device.communication.communicationMethod == "MEASURE") {
          if (this.receiving) {
            this.receiving = false;
            stopVitalsMeasure(
              device,
              this.vitalToAdd || {
                identifier: that.$store.state.vitalGroupIdentifier,
              },
              (response) => {
                console.log(response);
              },
              (err) => {
                console.log(err);
              }
            );
            if (this.response) {
              this.response.data.forEach((measuredVital) => {
                that.vitals.forEach((vital) => {
                  if (vital.identifier == measuredVital.type) {
                    let convertedVital = that.handleUnitConversion(vital.unit, {
                      name: measuredVital.type,
                      value: Number(measuredVital.value),
                      unit: measuredVital.unit,
                    });

                    if (convertedVital.value % 1 == 0) {
                      vital.value = convertedVital.value;
                    } else {
                      vital.value = math.format(convertedVital.value, {
                        notation: "fixed",
                        precision: 2,
                      });
                    }
                    vital.unit.primary = convertedVital.unit;
                    return;
                  }
                });
              });

              this.receiving = false;

              console.log(JSON.stringify(device));
              that.showVitals = false;
              setTimeout(() => {
                that.showVitals = true;
              }, 100);
              this.loader.hide();
              that.$forceUpdate();
            }
          } else {
            this.response = null;
            this.loader = this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            this.receiving = true;
            startVitalsMeasure(
              device,
              this.vitalToAdd || {
                identifier: that.$store.state.vitalGroupIdentifier,
              },
              (response) => {
                console.log(response);
                if (!this.continuousDevice) {
                  if (!this.continuousDevice) {
                    if (
                      response.deviceType == "MinttiHealthMonitor" ||
                      response.deviceType == "MinttiVision"
                    ) {
                      if (response.event && response.event.type == "glucose") {
                        if (response.event.value == "testPaperReady") {
                          this.loader.hide();
                          this.MinttiGlucometerMessage =
                            "Test paper ready. Add a blood drop";
                        }
                        if (response.event.value == "glucose") {
                          this.MinttiGlucometerMessage = "";
                          response.data.forEach((measuredVital) => {
                            that.vitals.forEach((vital) => {
                              if (vital.identifier == measuredVital.type) {
                                let convertedVital = that.handleUnitConversion(
                                  vital.unit,
                                  {
                                    name: measuredVital.type,
                                    value: Number(measuredVital.value),
                                    unit: measuredVital.unit,
                                  }
                                );

                                if (convertedVital.value % 1 == 0) {
                                  vital.value = convertedVital.value;
                                } else {
                                  vital.value = math.format(
                                    convertedVital.value,
                                    {
                                      notation: "fixed",
                                      precision: 2,
                                    }
                                  );
                                }
                                vital.unit.primary = convertedVital.unit;
                                return;
                              }
                            });
                          });
                        }
                      } else {
                        response.data.forEach((measuredVital) => {
                          that.vitals.forEach((vital) => {
                            if (vital.identifier == measuredVital.type) {
                              let convertedVital = that.handleUnitConversion(
                                vital.unit,
                                {
                                  name: measuredVital.type,
                                  value: Number(measuredVital.value),
                                  unit: measuredVital.unit,
                                }
                              );

                              if (convertedVital.value % 1 == 0) {
                                vital.value = convertedVital.value;
                              } else {
                                vital.value = math.format(
                                  convertedVital.value,
                                  {
                                    notation: "fixed",
                                    precision: 2,
                                  }
                                );
                              }
                              vital.unit.primary = convertedVital.unit;
                              return;
                            }
                          });
                        });

                        disconnect(device);
                        this.receiving = false;

                        console.log(JSON.stringify(device));
                        that.showVitals = false;
                        setTimeout(() => {
                          that.showVitals = true;
                        }, 100);
                        this.loader.hide();
                        that.$forceUpdate();
                      }
                    }
                  } else {
                    this.loader.hide();
                    let vitalObj = this.vitalToAdd || {
                      identifier: that.$store.state.vitalGroupIdentifier,
                    };
                    if (response && response.data) {
                      this.response = response;
                    } else if (
                      response &&
                      response.event &&
                      vitalObj &&
                      vitalObj.identifier &&
                      response.event.type == vitalObj.identifier &&
                      response.event.value == "readingEnd"
                    ) {
                      this.retrieveVital(device);
                    }
                  }
                } else {
                  this.loader.hide();
                  let vitalObj = this.vitalToAdd || {
                    identifier: that.$store.state.vitalGroupIdentifier,
                  };
                  if (response && response.data) {
                    this.response = response;
                  } else if (
                    response &&
                    response.event &&
                    vitalObj &&
                    vitalObj.identifier &&
                    response.event.type == vitalObj.identifier &&
                    response.event.value == "readingEnd"
                  ) {
                    this.retrieveVital(device);
                  }
                }
              },
              (err) => {
                this.loader.hide();
                this.receiving = false;
                swal.fire({
                  type: "error",
                  title: that.$t("message.bookings4"),
                  text: that.$t("message.vitals8"),
                });
                console.log(err);
                if (that.connectedDevicesEnabled) {
                  disconnect(that.deviceToAddVital);
                }
              }
            );
          }
        }
      }
    },
    getValue(vital) {
      let value = "";
      if (this.response && this.response.data) {
        for (let _vital of this.response.data) {
          if (_vital.type == vital.identifier) {
            value = _vital.value;
          }
        }
      }
      return value;
    },
    goToScan() {
      this.$store.commit("setState", {
        stateName: "deviceToScan",
        stateValue: this.deviceToAddVital,
      });
      this.$router.push("/scanvital");
    },
    getFormattedTime(time) {
      return moment(time).format("DD-MM-YYYY, hh:mm a");
    },
    async uploadVitals() {
      try {
        let vitals = {};
        this.vitals.forEach((vital) => {
          if (vital.value) {
            vitals[vital.identifier] = {
              name: vital.displayName[this.$i18n.locale],
              value: vital.value,
              unit: vital.unit.primary,
            };
          }
        });
        console.log(vitals);
        //Save only when object is not empty
        if (!$.isEmptyObject(vitals)) {
          //Save vitals to ES
          let vital = vitals;

          let vitalsData = [];

          //Generating vitals data object to save
          for (var vitalName in vital) {
            if (Number(vital[vitalName].value)) {
              vitalsData.push({
                patientId: this.$store.state.patient.patientId,
                value: Number(vital[vitalName].value),
                name: vitalName,
                unit: vital[vitalName].unit,
                provider: "manual",
                timestamp: new Date(this.date._date),
              });
            }
          }
          console.log(vitalsData);
          this.loader = this.$loading.show({
            // Optional parameters
            container: null,
            canCancel: false,
          });
          await this.$store.dispatch("saveVitalsData", vitalsData);
          this.loader.hide();
          swal.fire({
            title: this.$t("message.Saved!"),
            type: "success",
            timer: 2000,
          });
          if (this.IS_PATIENT) {
            socket.emit("latestVitalsUpdate", {
              caregroupId: this.user.caregroup._id || this.user.caregroup,
              patientId: this.user.patientId,
            });
          }
        } else {
          swal.fire({
            title: this.$t("message.Cannot share vitals"),
            text: this.$t("message.Vitals are empty"),
            type: "info",
            timer: 2000,
          });
        }
      } catch (e) {
        if (this.loader && this.loader.hide) {
          this.loader.hide();
        }
        console.log(e);
        swal.fire({
          title: this.$t("message.Couldn't Share!"),
          type: "error",
          timer: 5000,
        });
      }
    },
    handleUnitConversion(unitMetadata, reading) {
      //reading.unit = reading.unit.toLowerCase();
      if (reading.unit == unitMetadata.primary) {
        return reading;
      }

      if (isNaN(reading.value)) {
        return reading;
      }

      if (unitMetadata.secondary) {
        var conversionStr = unitMetadata.secondary[reading.unit];
      } else {
        return reading;
      }

      if (!conversionStr) {
        return reading;
      }

      var conversionFunc = math.eval("f(x) = " + conversionStr);
      var convertedVal = conversionFunc(Number(reading.value));
      reading.value = convertedVal;
      reading.unit = unitMetadata.primary;

      return reading;
    },
    goTohelp(help) {
      this.$store.commit("setState", {
        stateName: "vitalsHelp",
        stateValue: help,
      });
      this.$router.push("/vitalshelp");
    },
    addVital(data) {
      if (data.content && data.content.data) {
        this.response = data.content;
        data.content.data.forEach((measuredVital) => {
          this.vitals.forEach((vital) => {
            if (vital.identifier == measuredVital.type) {
              let convertedVital = this.handleUnitConversion(vital.unit, {
                name: measuredVital.type,
                value: Number(measuredVital.value),
                unit: measuredVital.unit,
              });

              if (convertedVital.value % 1 == 0) {
                vital.value = convertedVital.value;
              } else {
                vital.value = math.format(convertedVital.value, {
                  notation: "fixed",
                  precision: 2,
                });
              }
              vital.unit.primary = convertedVital.unit;
              return;
            }
          });
        });
      }
    },
    stopVital(device) {
      let vitalIdentifier = this.vitalToAdd
        ? this.vitalToAdd.identifier
        : this.$store.state.vitalGroupIdentifier;

      socket.emit("control-hub:stopmeasure", {
        endpoint: this.endpoint.name,
        deviceIdentifier: device.identifier,
        vitalIdentifier: vitalIdentifier,
      });

      this.receiving = false;
      this.showVitals = false;
      setTimeout(() => {
        this.showVitals = true;
      }, 100);
      this.$forceUpdate();
    },
  },
  computed: {
    ...mapState({
      activePatientVitals: (state) => state.activePatientVitals,
      endpoint: (state) => state.endpoint,
    }),
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    deviceToAddVital() {
      return this.$store.state.deviceToAddVital;
    },
    vitals() {
      return this.$store.state.vitalsToAdd;
    },
    errorMessages() {
      return this.$store.state.errorMessages;
    },
    vitalToAdd() {
      return this.$store.state.vitalToAdd;
    },
  },
};
</script>
<style>
.low-battery-text {
  font-size: 1.3em;
  color: red;
}

.vital-card {
  border-radius: 2rem;
}

.vital-image {
  margin-top: 3px;
  margin-left: 3px;
  height: 55px;
  width: 55px;
}

.device-vital-image {
  width: 3em;
  height: 3em;
  margin: 0;
  position: relative;
  top: 0.8em;
}

.el-select .el-input .el-input__inner {
  background-color: transparent;
  border: 1px solid #e3e3e3;
  border-radius: 30px;
  color: black;
}

.has-success:after,
.has-danger:after {
  display: none;
}

.info-horizontal .icon.icon-circle {
  margin-top: 0px;
}

.vital-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(2);
}

.indicator svg polyline {
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.indicator svg polyline#back {
  stroke: var(--color-primary) 8c;
}

.indicator svg polyline#front {
  stroke: var(--color-primary);
  stroke-dasharray: 12, 36;
  stroke-dashoffset: 48;
  animation: dash 1s linear infinite;
}

.cta {
  position: fixed;
  bottom: 20px;
  inset-inline-end: 30px;
  color: #222;
  font-weight: bold;
}

@-moz-keyframes dash {
  62.5% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash {
  62.5% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
}

@-o-keyframes dash {
  62.5% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  62.5% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: 0;
  }
}

#chartjs-tooltip {
  transition: left 0.5s, top 0.5s;
  border-radius: 5px;
}

#chartj-span {
  height: 1em;
  width: 1em;
  display: inline-block;
  border: 1px solid white;
  margin-right: 5px;
  margin-top: 5px;
}
</style>
<style scoped>
.form-control[disabled] {
  background-color: transparent;
  color: #2c2c2c;
}

/deep/ .el-select .el-input .el-input__inner[disabled] {
  background-color: transparent;
}

/deep/ .el-select .el-input .el-input__inner[disabled] {
  background-color: 1px solid #e3e3e3;
}

/deep/ .card .card-body {
  padding: 15px 0px;
}

.selected-period {
  background: var(--color-primary);
  color: white;
}

/deep/ .tui-datepicker {
  margin-left: 17%;
}
</style>
